import { render, staticRenderFns } from "./AlertBox.vue?vue&type=template&id=0da3c9f2&scoped=true"
import script from "./AlertBox.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertBox.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AlertBox.vue?vue&type=style&index=0&id=0da3c9f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da3c9f2",
  null
  
)

export default component.exports